import { render, staticRenderFns } from "./AssignMaintainerModal.vue?vue&type=template&id=6982a8ae&scoped=true&"
import script from "./AssignMaintainerModal.vue?vue&type=script&lang=js&"
export * from "./AssignMaintainerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6982a8ae",
  null
  
)

export default component.exports